import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { fileUrl } from "@/lib/api";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export default function ImageGallery({ images = [], name = "Produto" }) {
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState(false);
  const list = images.length ? images : [];
  const current = list[active];

  const prev = () => setActive((i) => (i - 1 + list.length) % list.length);
  const next = () => setActive((i) => (i + 1) % list.length);

  return (
    <div className="grid grid-cols-5 gap-3">
      <div className="hidden md:flex col-span-1 flex-col gap-3 max-h-[600px] overflow-y-auto">
        {list.map((img, i) => (
          <button
            key={img.path}
            onClick={() => setActive(i)}
            data-testid={`gallery-thumb-${i}`}
            className={`aspect-square overflow-hidden border transition-colors ${
              active === i ? "border-white" : "border-white/10 hover:border-white/40"
            }`}
          >
            <img src={fileUrl(img.path)} alt={`${name} ${i}`} className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
      <div className="col-span-5 md:col-span-4">
        <div
          className="relative aspect-[4/5] bg-[#0A0A0C] border border-white/10 overflow-hidden cursor-zoom-in"
          onClick={() => current && setZoom(true)}
          data-testid="gallery-main-image"
        >
          {current ? (
            <img
              src={fileUrl(current.path)}
              alt={name}
              className="absolute inset-0 w-full h-full object-cover"
            />
          ) : (
            <div className="absolute inset-0 grid place-items-center text-white/20 font-display text-6xl tracking-tighter">AM</div>
          )}
          {list.length > 1 && (
            <>
              <button
                onClick={(e) => { e.stopPropagation(); prev(); }}
                className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/60 border border-white/20 h-10 w-10 grid place-items-center text-white hover:bg-black"
                aria-label="Imagem anterior"
                data-testid="gallery-prev"
              >
                <ChevronLeft size={18} />
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); next(); }}
                className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/60 border border-white/20 h-10 w-10 grid place-items-center text-white hover:bg-black"
                aria-label="Próxima imagem"
                data-testid="gallery-next"
              >
                <ChevronRight size={18} />
              </button>
            </>
          )}
        </div>
        <div className="md:hidden flex gap-2 mt-3 overflow-x-auto">
          {list.map((img, i) => (
            <button
              key={img.path}
              onClick={() => setActive(i)}
              className={`shrink-0 h-16 w-16 border ${active === i ? "border-white" : "border-white/10"}`}
            >
              <img src={fileUrl(img.path)} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      </div>

      <Dialog open={zoom} onOpenChange={setZoom}>
        <DialogContent className="max-w-5xl bg-black border-white/10 p-0 overflow-hidden">
          <button
            onClick={() => setZoom(false)}
            className="absolute top-3 right-3 z-10 h-10 w-10 grid place-items-center bg-black/60 border border-white/20 text-white"
            aria-label="Fechar"
          >
            <X size={18} />
          </button>
          {current && (
            <img src={fileUrl(current.path)} alt={name} className="w-full h-auto max-h-[90vh] object-contain" />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
